import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export const NotFoundPage: React.FC = () => {
    useDocumentTitle('404 - Không tìm thấy trang');

    return (
        <div className="min-h-app flex flex-col items-center justify-center
                        lg-app-bg px-4">
            <div className="text-center space-y-8">
                <div className="space-y-4">
                    <img
                        src="/images/logo.svg"
                        alt="404 Logo"
                        className="w-24 h-24 mx-auto animate-bounce"
                    />
                    <h1 className="text-6xl font-bold text-blue-600 dark:text-blue-400">
                        404
                    </h1>
                    <h2 className="text-2xl font-semibold text-slate-800 dark:text-slate-200">
                        Không tìm thấy trang
                    </h2>
                    <p className="text-slate-600 dark:text-slate-400 max-w-md mx-auto">
                        Không tồn tại trang này hoặc thông tin này trong hệ thống.
                    </p>
                </div>

                <Link
                    to="/"
                    className="inline-flex items-center px-6 py-3 rounded-lg
                             text-white bg-slate-800
                             hover:bg-slate-900 shadow-sm
                             transition-all duration-200"
                >
                    <FontAwesomeIcon icon={faHome} className="mr-2" />
                    Về trang chủ
                </Link>
            </div>

            <footer className="fixed bottom-0 w-full py-4 safe-bottom text-center text-sm
                             text-slate-500 dark:text-slate-400
                             bg-white/30 dark:bg-white/5 sm:backdrop-blur border-t border-white/40 dark:border-white/10">
                © 2025 Bùi Tiến Tuân. All rights reserved.
            </footer>
        </div>
    );
};